/**
 *
 *
 * @author Todd Miller <todd.miller@tricomb2b.com>
 */

(function ($) {
  'use strict';

  let $sliders;

  Drupal.behaviors.initializeBasicCardSliders = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  /**
   * Cache elements, attach event handlers.
   */
  function initialize() {
    $sliders = $('.basic-card-slider > div');

    if (!$sliders.length) return false;

    $sliders.each(function () {
      const $el = $(this);

      $el.slick({
        infinite: false,
        slidesToShow: 3,
        prevArrow: false,
        nextArrow: false,
        speed: 300,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 2250,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1560,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 850,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    });
  }
})(jQuery);
